import { createSelector } from '@reduxjs/toolkit';
import { ParameterMethodsListState } from 'ducks/parameter-methods-list/slices';
import { RootState } from 'store';

const parameterMethodsListSlice = (state: RootState) => state.parameter_methods_list;

export const selectParameterMethodsList = createSelector(
  [parameterMethodsListSlice],
  (state): ParameterMethodsListState => state,
);
